import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AssistanceApplicationDocumentUploadComponent} from "./assistance-application-document-upload.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslatePipe} from "@ngx-translate/core";
import {TooltipModule} from "ngx-bootstrap/tooltip";

@NgModule({
    declarations: [
        AssistanceApplicationDocumentUploadComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe,
        TooltipModule
    ],
    exports: [
        AssistanceApplicationDocumentUploadComponent
    ]
})
export class AssistanceApplicationDocumentUploadModule {
}
